<template>
  <div>
    <vs-card class="card_with_img_details mb-4">
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h4>Details</h4>
        <vs-tooltip color="primary" position="top" text="Status">
          <span
            style="min-width: 70px; min-height: 35px"
            class="cstm-status-badge"
            :class="getStatusName().toLowerCase()"
            >{{ getStatusName() }}</span
          >
        </vs-tooltip>
      </div>
      <div class="img_holder text-center">
        <span
          v-if="course_details.client_user.picture"
          class="b-avatar badge-light-danger rounded"
          style="width: 150px; height: 104px"
        >
          <img
            :src="course_details.client_user.picture"
            alt="avatar"
          />
        </span>
        <svg v-else style="width: 100px; height: 50px; object-fit: contain;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
        <h4 class="mt-3">
          {{ course_details.client_user.first_name }}
          {{ course_details.client_user.last_name }}
        </h4>
      </div>
      <div class="content_holder">
        <vs-row>
          <vs-col vs-lg="6" vs-sm="12">
            <vs-row>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="BookIcon" />
                <b class="pr-2">Name: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>{{ course_details.assignment_builder.title }}</div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="BookIcon" />
                <b class="pr-2">Subject: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.assignment_builder.has_all_subject
                      ? "General"
                      : subject
                  }}
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="6" vs-sm="12">
            <vs-row>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="CalendarIcon" />
                <b class="pr-2">Received: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.submitted_on
                      ? $moment(Date.parse(course_details.submitted_on)).format(dateTimeFormat)
                      : "Not Available"
                  }}
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="CalendarIcon" />
                <b class="pr-2">Deadline: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.assignment_builder.deadline
                      ? $moment(Date.parse(course_details.assignment_builder.deadline)).format(dateTimeFormat)
                      : "Not Available"
                  }}
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <!-- question and answer -->
    <vs-card class="question_card">
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h4>Worksheet</h4>
      </div>
      <div>
        <div
          class="light-border p-4 my-2"
          v-for="(question, index) in course_details.assignment_builder
            .questions"
          :key="index"
        >
          <div class="flex flex-wrap justify-between">
            <div class="inline-flex w-4/5">
              <b style="vertical-align: top" class="pr-2"
                >Q.{{ index + 1 }})
              </b>
              <p class="question-container w-full">
                {{ question.title }}
              </p>
            </div>
          </div>
          <vs-textarea
            v-if="
              question.question_input_type_id === 1 ||
              question.question_input_type_id === 2
            "
            label="Write your answer here"
            v-model="question.short_answer"
          />
          <div v-if="question.question_input_type_id === 3">
            <div
              class="options-holder"
              v-for="(options, index) in question.questions_options"
              :key="index"
            >
              <vs-radio
                v-model="question.answer"
                :name="`custom${index}`"
                :vs-value="options.id"
                :ref="`custom${index}`"
              >
                <p>
                  <span>{{ options.option_name }}</span>
                  <!-- <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/correct.png"
                      v-if="options.is_answer"
                    />
                  </span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/incorrect.png"
                      v-if="
                        !options.is_answer &&
                        checkifSelected(
                          question.question_input_type.field_type,
                          question.questions_answers,
                          options.id
                        )
                      "
                    />
                  </span> -->
                </p>
              </vs-radio>
            </div>
          </div>
          <div
            v-if="
              question.question_input_type_id === 4 ||
              question.question_input_type_id === 6
            "
          >
            <div
              class="options-holder"
              v-for="(options, index) in question.questions_options"
              :key="index"
            >
              <vs-checkbox
                v-model="question.answer"
                :vs-value="options.id"
                :ref="`custom${index}`"
              >
                <p>
                  <span>{{ options.option_name }}</span>
                  <!-- <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/correct.png"
                      v-if="options.is_answer"
                    />
                  </span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/incorrect.png"
                      v-if="
                        !options.is_answer &&
                        checkifSelected(
                           question.question_input_type.field_type,
                          question.questions_answers,
                          options.id
                        )
                      "
                    />
                  </span> -->
                </p>
              </vs-checkbox>
              <br />
            </div>
          </div>
          <div v-if="question.question_input_type_id === 5">
            <v-select
              class="options-holder"
              v-model="question.answer"
              :name="`custom${index}`"
              :options="question.questions_options"
              :reduce="(option) => option.id"
              label="option_name"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-wrap justify-between items-center mt-4">
        <vs-button color="danger" type="border" @click="$router.push({name: 'Report'})">Cancel</vs-button>
        <vs-button @click="submitAnswer('final_submit')">Save</vs-button>
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { fetchCustomerList, reportWorkSubmit } from '@/api/course-work'
export default {
  components: {
    vSelect
  },
  created () {},
  mounted () {
    this.customer_id = localStorage.getItem('customer_id')
    this.assignment_builder__user_id =
      this.$route.params.assignment_builder_user_id
    this.fetchCourseWorkDetails()
    this.getRepositoryId()
  },
  data () {
    return {
      assignment_type_id: '',
      dateTimeFormat: `${JSON.parse(localStorage.getItem('localization')).date_format} ${JSON.parse(localStorage.getItem('localization')).time_format}`,
      statusArray: [
        {
          id: 1,
          status: 'Assigned'
        },
        {
          id: 2,
          status: 'Filled In'
        },
        {
          id: 3,
          status: 'Submitted'
        },
        {
          id: 4,
          status: 'Completed'
        },
        {
          id: 5,
          status: 'Delayed'
        }
      ],
      repository_id: null,
      customer_id: null,
      assignment_builder__user_id: null,
      course_details: null,
      subject: []
    }
  },
  methods: {
    getStatusName () {
      return this.statusArray[this.course_details.teacher_status - 1].status
    },
    setQuestionModalAnswer () {
      console.log(this.course_details.assignment_builder.questions)
      this.course_details.assignment_builder.questions.forEach((ele) => {
        if (
          ele.question_input_type_id === 3 ||
          ele.question_input_type_id === 5
        ) {
          ele.Questiontype = 'radio'
          this.$set(
            ele,
            'answer',
            ele.teacher_answers.assignment_question_answer_id
              ? ele.teacher_answers.assignment_question_answer_id
              : null
          )
        } else if (
          ele.question_input_type_id === 4 ||
          ele.question_input_type_id === 6
        ) {
          ele.Questiontype = 'multiselect'
          this.$set(
            ele,
            'answer',
            ele.teacher_answers.assignment_question_answer_id
              ? ele.teacher_answers.assignment_question_answer_id
              : []
          )

        } else {
          this.$set(
            ele,
            'short_answer',
            ele.teacher_answers.short_answer !== null
              ? ele.teacher_answers.short_answer
              : null
          )
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = 'shortanswer'
        }
      })
    },
    checkifSelected (Questiontype, correct_answer_id, correct_options_id) {
      if (Questiontype === 'multiselect') {
        if (correct_answer_id.includes(correct_options_id)) {
          return true
        } else {
          return false
        }
      } else if (Questiontype === 'radio') {
        if (correct_answer_id === correct_options_id) {
          return true
        } else {
          return false
        }
      }
    },
    async getRepositoryId () {
      try {
        const payload = {
          client: true,
          platform_module_id: 49
        }

        const { data } = await getRepoId(this.customer_id, payload)
        this.repository_id = data.data[0].id
      } catch (error) {
        console.warn(error)
      }
    },
    getIdFile (obj) {
      this.course_details.assignment_builder.questions[
        obj.question_index
      ].files.push({
        id: null,
        file_id: obj.file_id
      })
    },
    deletedIndex ({ question_detail_index, fileIndex }) {
      console.log('hi')
      this.course_details.assignment_builder.questions[
        question_detail_index
      ].files.splice(fileIndex, 1)
      this.course_details.assignment_builder.questions[
        question_detail_index
      ].files.splice(fileIndex, 1)
    },
    async submitAnswer (submit_type) {
      let payload = []
      console.log(this.course_details.assignment_builder.questions)

      payload = this.course_details.assignment_builder.questions
        .map((ele) => {
          return {
            type: 1,
            assignment_question_id: ele.id,
            assignment_question_answer_id: ele.answer,
            question_type: 2, // question bank
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype,
            files: ele.files
          }
        })
        .filter((ele) => {
          if (
            ele.Questiontype === 'radio' ||
            ele.Questiontype === 'multiselect'
          ) {
            return ele.answer !== null
          } else if (ele.Questiontype === 'fileupload') {
            return ele.files.length > 0
          } else {
            return ele.short_answer !== null
          }
        })
      if (payload.length) {
        this.saveAnswerQuestion(payload, submit_type)
      }
    },
    async saveAnswerQuestion (payload, submit_type) {
      try {
        console.log(this.QuestionModal)
        const answers = {
          answers: payload,
          platform_customer_id: this.customer_id,
          submit_type
        }
        console.log(answers)
        const data = await reportWorkSubmit(
          this.customer_id,
          this.assignment_builder__user_id,
          answers
        )
        const successMessage = 'Report updated successfully'
        this.$vs.notify({
          title: 'Success',
          text: `${successMessage}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

        this.$router.push({
          name: 'Report'
        })
      } catch (error) {
        console.log(error)
        this.$vs.notify({
          title: 'error',
          text: 'Something Went Wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    async fetchCourseWorkDetails () {
      try {
        const { data } = await fetchCustomerList(
          this.customer_id,
          this.assignment_builder__user_id
        )
        this.course_details = data.data.courseWork

        const subjectseparation =
          this.course_details.assignment_builder.subject.map((e) => {
            if (e.subject_name) {
              return e.subject_name
            }
          })
        this.subject = subjectseparation.join(', ')

        this.setQuestionModalAnswer()
        this.assignment_type_id = this.course_details.assignment_type_id

        // if(this.course_details.student_status==3){

        // const payload = {
        //   student_status:4,
        //   teacher_status:4
        // }

        // const data = await statusChng(this.customer_id,
        //   this.assignment_builder__user_id, payload)
        // }
      } catch (e) {
        //
      }
    }
  }
}
</script>
